
    import './styles.scoped.css';
    export default {
  "selectable-item": "awsui_selectable-item_15o6u_t05lo_145",
  "pad-bottom": "awsui_pad-bottom_15o6u_t05lo_167",
  "virtual": "awsui_virtual_15o6u_t05lo_171",
  "has-background": "awsui_has-background_15o6u_t05lo_174",
  "highlighted": "awsui_highlighted_15o6u_t05lo_177",
  "selected": "awsui_selected_15o6u_t05lo_177",
  "disabled": "awsui_disabled_15o6u_t05lo_195",
  "next-item-selected": "awsui_next-item-selected_15o6u_t05lo_205",
  "is-keyboard": "awsui_is-keyboard_15o6u_t05lo_217",
  "parent": "awsui_parent_15o6u_t05lo_221",
  "interactiveGroups": "awsui_interactiveGroups_15o6u_t05lo_225",
  "child": "awsui_child_15o6u_t05lo_241",
  "sticky": "awsui_sticky_15o6u_t05lo_247",
  "with-scrollbar": "awsui_with-scrollbar_15o6u_t05lo_259",
  "after-header": "awsui_after-header_15o6u_t05lo_265",
  "measure-strut": "awsui_measure-strut_15o6u_t05lo_300",
  "measure-strut-first": "awsui_measure-strut-first_15o6u_t05lo_309",
  "screenreader-content": "awsui_screenreader-content_15o6u_t05lo_313",
  "option-content": "awsui_option-content_15o6u_t05lo_319",
  "select-all": "awsui_select-all_15o6u_t05lo_323"
};
  